module.exports = __webpack_public_path__ + "static/media/pencil.bbc4e7cf.svg";